module.exports = {
      id: "home-bg-usage",
      viewBox: "0 0 1268 617",
      url: __webpack_public_path__ + "images/js_src_vue/page_islide_landing/sprite.30abe696.svg#home-bg-usage",
      toString: function () {
        return this.url;
      }
    }